import { ChevronRightIcon, StarIcon } from "@chakra-ui/icons";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import useUpgrade from "../hooks/useUpgrade";

// Mirrors the mobile PremiumBanner component: an amber-tinted, tappable row
// with a star badge, the reason tracking is limited, and an "Upgrade" affordance.
const PremiumBanner = ({ description, text, title, ...props }) => {
  const upgrade = useUpgrade();
  const bannerTitle = title || text;

  return (
    <Flex
      as="button"
      type="button"
      aria-label={`${bannerTitle}. Upgrade`}
      alignItems="center"
      minH="60px"
      w="100%"
      py="10px"
      px="12px"
      bg="rgba(255, 170, 0, 0.08)"
      borderWidth="1px"
      borderColor="rgba(255, 170, 0, 0.52)"
      borderRadius="10px"
      textAlign="left"
      _hover={{ bg: "rgba(255, 170, 0, 0.13)" }}
      _active={{ opacity: 0.72 }}
      onClick={upgrade}
      {...props}
    >
      <Center
        flexShrink={0}
        w="36px"
        h="36px"
        borderRadius="full"
        bg="rgba(255, 170, 0, 0.13)"
      >
        <StarIcon color="#FFAA00" boxSize="16px" />
      </Center>

      <Box flex="1" minW={0} ml="10px">
        <Text
          color="#FFFFFF"
          fontSize="14px"
          lineHeight="19px"
          fontWeight="600"
        >
          {bannerTitle}
        </Text>
        {!!description && (
          <Text mt="2px" color="#8F9BB3" fontSize="12px" lineHeight="16px">
            {description}
          </Text>
        )}
      </Box>

      <Flex alignItems="center" flexShrink={0} ml="10px">
        <Text
          color="#FFAA00"
          fontSize="12px"
          lineHeight="16px"
          fontWeight="700"
        >
          Upgrade
        </Text>
        <ChevronRightIcon color="#FFAA00" boxSize="16px" />
      </Flex>
    </Flex>
  );
};

export default PremiumBanner;
